module.exports = __webpack_public_path__ + "img/TIFG-logo.b18f0491.png";